import React from "react";
import { useAuthRedirect } from "../common/token-utils";

const AuthenticationGuard = ({ component: Component }) => {
  const accessToken = useAuthRedirect();

  if (!accessToken) {
    return null; // Prevent rendering if the user is not authenticated
  }

  return <Component />; // Render the protected component if authenticated
};


export default AuthenticationGuard;